import React from "react";

export default class FeedbackTile extends React.Component {
  render() {
    return (
      <div
        className={`feedback-tile 
					${this.props.visible ? "visible" : ""}
					${this.props.classNames}
					`}
        style={this.props.style}
        data-component="FeedbackTile"
      >
        {this.props.text}
      </div>
    );
  }
}
